import {
  Actions,
  NotificationType,
} from 'ha/modules/RealtimeMessaging/constants';

export const isConversationMessageAction = action =>
  action.type === Actions.RECEIVE_MESSAGE &&
  action.payload.type === NotificationType.conversationMessage;
